import React from "react";
import { useRouter } from "next/dist/client/router";
import Image from "next/future/image";

const Licen = ({ licen }) => {
  const { id, img, title, subtitle } = licen;
  const { locale } = useRouter();
  return (
    <>
      <div
        className="licen"
        data-aos="fade-up"
        data-aos-duration="300"
        data-aos-delay={id * 100}
      >
        <div className="img">
          {img && (
            <Image src={img} width={300} height={200} alt="" loading="lazy" />
          )}
        </div>
        <div className="p-data">
          <h4>{title?.[locale]}</h4>
          <p>{subtitle?.[locale]}</p>
        </div>
      </div>
    </>
  );
};

export default Licen;
